import { useEffect, useState } from 'react';
const getUserData = async (mainAppUrl, onError) => {
  let responseBody;
  try {
    const response = await fetch("".concat(mainAppUrl, "/api/users/signed_in"), {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    responseBody = await response.json();
  } catch (error) {
    onError(error, {
      message: 'Error while fetching user avatar URL'
    });
    return 'about/placeholder.svg';
  }
  return responseBody.avatar_url;
};
export const useUserAvatarUrl = (mainAppUrl, onError) => {
  const [userAvatarUrl, setUserAvatarUrl] = useState('about/placeholder.svg');
  useEffect(() => {
    const getAndSetUserAvatarUrl = async () => {
      setUserAvatarUrl(await getUserData(mainAppUrl, onError));
    };
    getAndSetUserAvatarUrl();
  }, [mainAppUrl, onError]);
  return userAvatarUrl;
};